import { VariableType } from "json-to-graphql-query";

const location = {
  city: true,
  radius: true,
  state: true,
  country: true,
  postal: true,
  latitude: true,
  longitude: true,
};

export class CapacityModel {
  /**
   * Get Capacity List
   * @param commonCarrierId
   * @param page
   * @param size
   */
  getList(commonCarrierId: string, page: number, size: number) {
    return {
      query: {
        getCarrierCapacity: {
          __args: {
            criteria: {
              commonCarrierId,
              page,
              size,
            },
          },
          totalRecords: true,
          capacity: {
            capacityId: true,
            capacityType: true,
            commonCarrierId: true,
            trailerType: true,
            origin: location,
            pickUpFromDate: true,
            pickUpToDate: true,
            preferredDays: true,
            destination: location,
            destinationStates: true,
            destinationCountry: true,
            lastUpdatedDateTime: true,
            lastUpdatedBy: true,
            lastUpdatedByPhoneNumber: true,
            lastUpdatedByEmail: true,
          },
        },
      },
    };
  }

  /**
   * Get Capacity List with count
   * @param commonCarrierId
   * @param page
   * @param size
   */
  getCarrierCapacityWithLoadCount(
    commonCarrierId: string,
    page: number,
    size: number,
    userId: string,
    upn: string,
    capacityType:string
  ) {
    return {
      query: {
        getCarrierCapacityWithLoadCount: {
          __args: {
            criteria: {
              commonCarrierId,
              page,
              size,
              userId,
              upn,
              capacityType
            },
          },
          totalRecords: true,
          totalPages: true,
          capacity: {
            capacityId: true,
            capacityType: true,
            commonCarrierId: true,
            trailerType: true,
            origin: location,
            pickUpFromDate: true,
            pickUpToDate: true,
            preferredDays: true,
            destination: location,
            destinationStates: true,
            destinationCountry: true,
            lastUpdatedDateTime: true,
            lastUpdatedBy: true,
            lastUpdatedByPhoneNumber: true,
            lastUpdatedByEmail: true,
            loadCount: true,
          },
        },
      },
    };
  }

  /**
   * Get Capacity loads
   * @param capacityId
   * @param userId
   */
  getCapacityLoad(capacityId: string, userId: string, sortColumn: string, sortDirection: string, page: number, size: number ) {
    return {
      query: {
        getCapacityLoad: {
          __args: {
            capacityId,
            userId,
            sortColumn,
            sortDirection,
            page,
            size
          },
          capacity: {
            capacityId: true,
            capacityType: true,
            commonCarrierId: true,
            trailerType: true,
            origin: {
              city: true,
              radius: true,
              state: true,
              country: true,
              postal: true,
              latitude: true,
              longitude: true,
            },
            pickUpFromDate: true,
            pickUpToDate: true,
            preferredDays: true,
            destination: {
              city: true,
              radius: true,
              state: true,
              country: true,
              postal: true,
              latitude: true,
              longitude: true,
            },
            destinationStates: true,
            destinationCountry: true,
            lastUpdatedDateTime: true,
            lastUpdatedBy: true,
            lastUpdatedByPhoneNumber: true,
            lastUpdatedByEmail: true,
            loadCount: true,
          },
          loadPostings: {
            loadId: true,
            loadPostingStatus: true,
            sourceSystem: true,
            isHazardous: true,
            isHighValue: true,
            isTemperatureControlled: true,
            totalDistance: true,
            distanceUOM: true,
            totalWeight: true,
            weightUOM: true,
            numberOfStops: true,
            transportMode: true,
            termsAndConditions: true,
            rate: {
              binRateIdentifier: true,
              totalCharge: true,
              lineHaulCharge: {
                charge: true,
                unitCharge: true,
                quantity: true,
                rateQualifier: true,
                chargeDescription: true,
              },
              fuelCharge: {
                charge: true,
                unitCharge: true,
                quantity: true,
                rateQualifier: true,
                chargeDescription: true,
              },
              accessorials: {
                accessorialCode: true,
                accessorialDescription: true,
                accessorialType: true,
                accessorialCharge: {
                  charge: true,
                  unitCharge: true,
                  quantity: true,
                  rateQualifier: true,
                  chargeDescription: true,
                },
              },
            },
            loadStop: {
              locationName: true,
              addressLine1: true,
              addressLine2: true,
              stopSequence: true,
              stopType: true,
              city: true,
              state: true,
              postalCode: true,
              country: true,
              stopId: true,
              appointmentFrom: true,
              appointmentTo: true,
              timeZone: true,
              deadHead: true,
              appointmentState: true,
              specialServices: {
                specialServiceDesc: true,
              },
            },
            buyAllowed: true,
            exclusiveLoad: true,
            managedEquipment: true
          },
        },
      },
    };
  }

  /**
   * Add Capacity Model
   */
  addCapacity() {
    return {
      addCarrierCapacity: {
        __variables: {
          input: "CapacityInput",
        },
        addCarrierCapacity: {
          __args: {
            input: new VariableType("input"),
          },
          capacityID: true,
          lastUpdatedByUserName: true,
        },
      },
    };
  }

  /**
   *  Update Capacity Model
   */
  updateCapacity() {
    return {
      updateCarrierCapacity: {
        __variables: {
          input: "CapacityInput",
        },
        updateCarrierCapacity: {
          __args: {
            input: new VariableType("input"),
          },
        },
      },
    };
  }

  /**
   *
   * @param capacityId
   */
  deleteCapacity(capacityId: string) {
    return {
      mutation: {
        deleteCarrierCapacity: {
          __args: {
            capacityId,
          },
        },
      },
    };
  }
}
